import * as React from 'react';

import classnames from 'classnames';

import {ChevronDown} from '../icon/svg/chevron-down-icon';

import styles from './collapsible-chevron.module.css';

type Props = {
    isExpanded: boolean;
};

export function CollapsibleChevron(props: Props) {
    const chevronStyleName = classnames(styles['chevron-icon-container'], {
        [styles['chevron-icon-container--rotate']]: props.isExpanded,
    });

    return <ChevronDown size={12} className={chevronStyleName} />;
}
